// To create a new translation, add a YAML file with the required entries and
// link it here using the appropriate language code.

import zh from './zh.yml';
import pt from './pt.yml';
import ca from './ca.yml';
import cs from './cs.yml';
import da from './da.yml';
import de from './de.yml';
import el from './el.yml';
import en from './en.yml';
import es from './es.yml';
import fi from './fi.yml';
import fr from './fr.yml';
import gl from './gl.yml';
import hu from './hu.yml';
import hr from './hr.yml';
import it from './it.yml';
import nl from './nl.yml';
import no from './no.yml';
import oc from './oc.yml';
import ro from './ro.yml';
import sr from './sr.yml';
import sr_cyrl from './sr_cyrl.yml';
import sv from './sv.yml';
import tr from './tr.yml';
import pl from './pl.yml';
import ru from './ru.yml';

export default {
    ca,
    cs,
    da,
    de,
    el,
    en,
    zh,
    pt,
    es,
    fi,
    fr,
    gl,
    hu,
    hr,
    it,
    nl,
    no,
    oc,
    ro,
    sr,
    sr_cyrl,
    sv,
    tr,
    pl,
    ru,
};
